
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // Third-party libraries
import clsx from 'clsx';
import useTranslation from 'next-translate/useTranslation';
// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useStateWithReset from '@/utils/hooks/utils/useStateWithReset';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Layouts
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
// Components
import InfoBanner from '@/components/base/InfoBanner/CompoundBanner';
import ContactContainer from '@/components/pages/home/ContactContainer';
import HomeHeader from '@/components/pages/home/header/Header';
import KeyNumbers from '@/components/pages/home/keyNumbers';
import BlogPosts from '@/components/pages/home/newsArticles/BlogPosts';
import FAQArticles from '@/components/pages/home/newsArticles/FAQArticles';
import NewFeature from '@/components/pages/home/newsArticles/NewFeature';
import { HomeKeyActions } from '@/components/pages/home/keyActions';
function HomeContent() {
    const { user } = useUser();
    const { t } = useTranslation('home');
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const [error, setError, resetError] = useStateWithReset<string>(null);
    const isTrial = user?.trial;
    return (<>
            <div className={clsx('mb-9 @container', {
            'mt-10': !isTreeStructureActivated
        })}>
                <HomeHeader setError={setError}/>
                {error ? (<InfoBanner className="mt-8">
                        <InfoBanner.Icon />
                        <InfoBanner.Content title={t('commons:error')} message={error}/>
                        <InfoBanner.Close onClose={resetError}/>
                    </InfoBanner>) : null}
                <HomeKeyActions />
                {isTrial ? <ContactContainer /> : null}
                <h2 className="mt-8 font-GBold text-3xl">{t('key_numbers.title')}</h2>
                <p className="my-2 text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t('key_numbers.text')}
                </p>
                <KeyNumbers />
                <h2 className="my-8 font-GBold text-3xl">
                    {t('latest_news_and_articles_from_iconosquare')}
                </h2>
                <div className="grid grid-cols-4 gap-5">
                    <NewFeature />
                    <FAQArticles />
                </div>
                <div className="mt-11 grid grid-cols-1 gap-5 @lg:grid-cols-2 @4xl:grid-cols-3">
                    <BlogPosts />
                </div>
            </div>
            {!isTrial ? <ContactContainer withG2Review/> : null}
        </>);
}
const Home = () => {
    return (<WrapperSwitchLayout>
            <HomeContent />
        </WrapperSwitchLayout>);
};
export default Home;

    async function __Next_Translate__getStaticProps__1974424bbcd__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/home/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1974424bbcd__ as getStaticProps }
  